import config from "./config";
var axios = config();

export default {
  getAdditionalMaterialTypes() {
    return axios.get(
      "/api/AdditionalMaterialTypes/GetAdditionalMaterialTypes",
      {}
    );
  },

  // make a put request for each item in the array. data.map will return an array of promises. Promise.all will wait for all promises to resolve before returning the result.
  async putUpdateOpenClose(data) {
    return await Promise.all(
      data.map(async item => {
        return axios.put("/api/AdditionalMaterialTypes/UpdateOpenClose", item);
      })
    );
  }
};
